import { useLazyQuery } from "@apollo/client";
import { searchQuery } from "GraphQL/queries/dashboard";
import { get } from "lodash";
import { FETCH_POLICY } from "src/constants";
import LearningCheckinNotificaionIcon from "Assets/images/learning-notification-icon.svg";
import SurveyCheckinNotificaionIcon from "Assets/images/survey-checkin-notification-icon.svg";
import SkillRatingCheckinNotificaionIcon from "Assets/images/skillrating-checkin-notification-icon.svg";
import RequestFeedbackNotificationIcon from "Assets/images/request-feedback-search-icon.svg";
import { inputEventState, searchOptionsState } from "Recoil/General/atom";
import { useRecoilState } from "recoil";
import { anchorElState } from "Recoil/Checkins/atom";



export const searchBar =()=>{
  const [searchOptions, setSearchOptions] = useRecoilState(searchOptionsState);
  const [anchorEl, setAnchorEl] = useRecoilState(anchorElState);
  const [inputEvent, setInputEvent] = useRecoilState(inputEventState);
    const [searchQueryData, { loading }] = useLazyQuery(searchQuery, {
        fetchPolicy: FETCH_POLICY.networkOnly,
        onCompleted: (data) => {
          const userData = get(data, "getCompany.users.items", []);
          const targetData = get(
            data,
            "getCompany.listTargetCustom.items.0.targets",
            []
          );
          const checkinData = get(data, "getCompany.checkinSearch.items", []);
          const SSorPRData = get(data, "getCompany.successStorySearch.items", []);
          const userSearchResult = userData.map((user) => {
            return {
              type: "User",
              id: get(user, "id", ""),
              image: `${(get(user, "profileImage.fileName", "") || "").length
                ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
                  user,
                  "profileImage.fileName",
                  ""
                )}`
                : ""
                }`,
              name: `${get(user, "firstName", "")} ${get(user, "lastName", "")}`,
            };
          });
          const targetSearchResult = targetData.map((target) => {
            return {
              type: "Target",
              id: get(target, "id", ""),
              image: `${(get(target, "logo.fileName", "") || "").length
                ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
                  target,
                  "logo.fileName",
                  ""
                )}`
                : ""
                }`,
              name: get(target, "title", ""),
            };
          });
          const successStorySearchResult = SSorPRData.map((ssorpr) => {
            return {
              type: "SuccessStory",
              id: get(ssorpr, "id", ""),
              name: get(ssorpr, "title", ""),
              isPerformanceReview: get(ssorpr, "isPerformanceReview", ""),
            };
          });
          const checkinSearchResult = checkinData.map((checkin) => {
            let image = "";
            const type = get(checkin, "checkInType", "");
            switch (type) {
              case "LEARNING":
                image = LearningCheckinNotificaionIcon;
                break;
              case "SURVEY":
                image = SurveyCheckinNotificaionIcon;
                break;
              case "SKILLRATING":
                image = SkillRatingCheckinNotificaionIcon;
                break;
              case "REQUESTFEEDBACK":
                image = RequestFeedbackNotificationIcon;
              default:
                break;
            }
            return {
              type: "Checkin",
              id: get(checkin, "id", ""),
              image,
              name: get(checkin, "name", ""),
              targetId: get(checkin, "checkInTargetId", ""),
            };
          });
          setSearchOptions([
            ...userSearchResult,
            ...targetSearchResult,
            ...checkinSearchResult,
            ...successStorySearchResult,
          ]);
          setAnchorEl(inputEvent);
          // setInputText("");
        },
      });

      return {searchQueryData,loading}
}